import React from 'react';
import UserInfo from './UserInfo';
import defaultUser from '../../Constants/defaultUser';
import styles from '../../Assets/Styles/Components/Navbar/Navbar.module.css';
import cNames from '../../Utility/utility';

type Props = {
	toggleCollapse: () => void;
};

const Navbar: React.FC<Props> = (props: Props) => {
	const { toggleCollapse } = props;

	return (
		<div className={styles.navbar}>
			<div className={styles.rightSection}>
				<button type="button" className={cNames(styles.menuButton, styles.sidebarToggle)} onClick={toggleCollapse}>
					<i className="fas fa-bars" />-
				</button>
			</div>
			<div className={styles.leftSection}>
				{/* <button type="button" className={styles.cartButton}>
					<i className={cNames('far fa-shopping-cart', styles.puls)} />
				</button> */}
				<UserInfo {...defaultUser} />
			</div>
		</div>
	);
};

export default Navbar;
